import { StateUtils } from '@spartacus/core';
import { ORGANIZATION_ON_CART } from '../cart-state';

export const SET_ORGANIZATION_TO_CART = '[Cart] Set Organization To Cart';
export const SET_ORGANIZATION_TO_CART_SUCCESS = '[Cart] Set Organization To Cart Success';
export const SET_ORGANIZATION_TO_CART_FAIL = '[Cart] Set Organization To Cart Fail';
export const SET_ORGANIZATION_TO_CART_RESET = '[Cart] Set Organization To Cart Reset';

export class SetOrganizationToCart extends StateUtils.LoaderLoadAction {
  readonly type = SET_ORGANIZATION_TO_CART;

  // null для физика
  constructor(public payload: string | null) {
    super(ORGANIZATION_ON_CART);
  }
}

export class SetOrganizationToCartSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = SET_ORGANIZATION_TO_CART_SUCCESS;

  constructor() {
    super(ORGANIZATION_ON_CART);
  }
}

export class SetOrganizationToCartFail extends StateUtils.LoaderFailAction {
  readonly type = SET_ORGANIZATION_TO_CART_FAIL;

  constructor(public payload: unknown) {
    super(ORGANIZATION_ON_CART);
  }
}

export class SetOrganizationToCartReset extends StateUtils.LoaderResetAction {
  readonly type = SET_ORGANIZATION_TO_CART_RESET;

  constructor() {
    super(ORGANIZATION_ON_CART);
  }
}
